import { PlainButton } from "@jugl-web/ui-kit";
import { removeMarkdown, useTranslations } from "@jugl-web/utils";
import React, { useEffect, useState } from "react";
import {
  getFileImagePath,
  getFileType,
} from "@jugl-web/domain-resources/tasks/components/TaskAttachments/utils";
import { mentionifyString } from "@jugl-web/utils/utils/Mentionify";
import { ReactComponent as CrossIcon } from "./assets/cross.svg";
import { ReactComponent as PlayIcon } from "./assets/play.svg";

export const CommentActionInfo: React.FC<{
  text: string;
  attachments: string[];
  onCancel: () => void;
  isCancelDisabled: boolean;
}> = ({ text, onCancel, isCancelDisabled, attachments }) => {
  const { t } = useTranslations();

  const [hasError, setHasError] = useState(false);

  const firstAttachment = attachments[0];

  const fileType = firstAttachment ? getFileType(firstAttachment) : undefined;

  const isImage = fileType === "image";
  const isVideo = fileType === "video";

  const showFallback = hasError || (!isImage && !isVideo);

  useEffect(() => {
    setHasError(false);
  }, [firstAttachment]);

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2 overflow-hidden">
        {firstAttachment && (
          <div className="relative h-10 w-10 shrink-0 overflow-hidden rounded border border-solid border-dark-100 bg-gradient-to-b from-white to-[#CDE2F2]">
            {!showFallback ? (
              <>
                {isImage && (
                  <img
                    src={firstAttachment}
                    alt=""
                    className="h-full w-full object-cover"
                    onError={() => setHasError(true)}
                  />
                )}

                {isVideo && (
                  <>
                    <video
                      src={firstAttachment}
                      className="h-full w-full object-cover"
                      muted
                      preload="metadata"
                      onError={() => setHasError(true)}
                    />
                    <PlayIcon className="absolute top-1/2 left-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 text-white" />
                  </>
                )}
              </>
            ) : (
              <img
                src={getFileImagePath(firstAttachment, "sm")}
                alt=""
                className="absolute top-1/2 left-1/2 max-h-6 max-w-6 -translate-x-1/2 -translate-y-1/2"
              />
            )}
          </div>
        )}

        <div className="flex flex-col gap-0.5 overflow-hidden">
          <span className="font-secondary text-sm font-medium text-primary">
            {t({
              id: "common.edit",
              defaultMessage: "Edit",
            })}
          </span>
          <span className="truncate font-secondary text-sm text-grey-800">
            {firstAttachment
              ? t(
                  {
                    id: "tasks-page.files-count",
                    defaultMessage:
                      "{count} {count, plural, one {File} other {Files}}",
                  },
                  { count: attachments.length }
                )
              : mentionifyString(removeMarkdown(text))}
          </span>
        </div>
      </div>
      <PlainButton
        className="disabled:opacity-50"
        disabled={isCancelDisabled}
        onClick={onCancel}
      >
        <CrossIcon />
      </PlainButton>
    </div>
  );
};
